import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import {SURCHARGE_TYPES,RATE_PLAN_PRICING} from'../util/constants'
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";


export default class SurCharge {
    static buildRequest(pSurcharge,pHotelId,pSurchargePricing) {
        let returnValue = null;
        try {
            let body = pSurcharge

            if(body)
            {
                body.hotelId =pHotelId;
                body.roomId=body.roomObj.roomid;
                body.ratePlanId=body.ratePlan.id
                body.surchargeType=  body.surchargeType.value
                body.currency= (body.pricingType==pSurchargePricing.FIXED)?body.currency.code:null
              delete body.ratePlan
              delete body.roomObj
            }

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_SURCHARGE,
                "error in building body for UPDATE  SurCharge   api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.API_UPDATE_SURCHARGE,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_SURCHARGE,
                "error in getting Response from UPDATE SurCharge api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}